<form [formGroup]="form">
<div *ngVar="isModelBlocked || model.group.isEdited || model.subGroup.isEdited as isEditingProcess" class="table-fms overflow-x-auto max-height-77vh">
    <table id='fund-strategy-model' *ngIf="model.showMainTable">
<!-- HEADER -->
      <thead>
        <tr>
          <th class="size-xxxs">
            <app-three-dots-menu
              data-qa="three-dots-header"
              [disabled]="isEditingProcess"
              [matMenuTriggerFor]="isEditingProcess ? '' : menu"
              [class.cursor-not-allowed]="isEditingProcess"
              (click)="showNotificationForNewModel()"
            />
            <mat-menu #menu="matMenu">
              <ul class="list">
                <app-drop-down-item
                  class="width-100pcnt"
                  data-qa="fs-export-excel"
                  [text]="'Export'"
                  [iconNameAndStyling]="'excel.svg'"
                  (click)="exportGroupTable()">
                </app-drop-down-item>
              </ul>
            </mat-menu>
          </th>
          <th class="size-l min-width-10">
            <app-button
              data-qa="fs-add-new-gr"
              [type]="'grey-accent'"
              [size]="'xsmall'"
              [iconName]="'plus.svg'"
              [disabled]="isEditingProcess"
              (click)="showNotificationForNewModel()"
              (buttonClick)="addNewGroup()">
              Group
            </app-button>
          </th>
          <th class="blank-space size-xxxs"></th>
          <th class="size-s">Companies</th>
          <th class="size-s">Write-off</th>
          <th class="size-s">Exit</th>
          <th class="blank-space size-xxxs "></th>
          <th class="size-s">Investment</th>
          <th class="size-s">Proceed</th>
          <th class="size-s">Gain/(loss)</th>
          <th class="size-s">MOIC</th>
        </tr>
      </thead>
<!-- GROUP -->
    <ng-container formArrayName="fundStrategy">
      <tbody *ngFor="let group of form.controls.fundStrategy.controls; let grIndex = index; let last = last; let first = first"  [formGroupName]="grIndex" cdkDropList (cdkDropListDropped)="cdkDropSubGroup($event, group.controls.subGroups, grIndex)">
            <tr>
<!-- GROUP NAME -->
              <td colspan="2" *ngIf="model.group.editName.get(grIndex.toString()); else groupViewState">
               <app-input
                  formControlName = "name"
                  [attr.data-qa]="'fs-input-gr-name-' + grIndex"
                  [isShrinked]="true"
                  [suffixFirstIcon]="'close.svg; black-9'"
                  [suffixSecondIcon]="'check.svg; main-8'"
                  (suffixFirstIconEmitter)="editGroupOrSubGroup(grIndex.toString(), model.editStatus.decline, false)"
                  (suffixSecondIconEmitter)="editGroupOrSubGroup(grIndex.toString(), model.editStatus.confirm, false)">
                </app-input>
              </td>
<!-- VIEWER STATE -->
              <ng-template #groupViewState>
                <td class="size-xxs" [attr.data-qa]="'fs-toggle-sb-visibility' + grIndex" (click)="toggleSubGroupVisibility(grIndex)">
                  <app-table-group-icon
                    [opened]="model.subGroup.visibility[grIndex]?.visible">
                  </app-table-group-icon>
                </td>
                <td>
                    <div class="space-between-horizontal">
                      <div class="start-row-container row-gap-0p5">
                        <app-three-dots-menu
                          [attr.data-qa]="'tree-dots-gr' + grIndex"
                          [matMenuTriggerFor]="isEditingProcess ? '' : menu"
                          [disabled]="isEditingProcess"
                          [class.cursor-not-allowed]="isEditingProcess"
                          (click)="showNotificationForNewModel()">
                          <mat-menu #menu="matMenu">
                            <ul class="list">
                              <app-drop-down-item
                                *ngIf="!first"
                                [attr.data-qa]="'fs-move-up-sb' + grIndex"
                                class="width-100pcnt"
                                [text]="'Move up'"
                                [iconNameAndStyling]="'arrow-up.svg'"
                                (itemClick)="moveGroup(grIndex, 'up')">
                              </app-drop-down-item>
                              <app-drop-down-item
                                *ngIf="!last"
                                [attr.data-qa]="'fs-move-down-sb' + grIndex"
                                class="width-100pcnt"
                                [text]="'Move down'"
                                [iconNameAndStyling]="'arrow-down.svg'"
                                (itemClick)="moveGroup(grIndex, 'down')">
                              </app-drop-down-item>
                              <app-drop-down-item class="width-100pcnt"
                                data-qa="fs-duplicate-gr"
                                [text]="'Duplicate'"
                                [iconNameAndStyling]="'copy.svg'"
                                (click)="duplicateGroup(grIndex)">
                              </app-drop-down-item>
                              <app-drop-down-item class="width-100pcnt"
                                data-qa="fs-edit-gr-name"
                                [text]="'Edit'"
                                [iconNameAndStyling]="'edit.svg'"
                                (click)="editGroupOrSubGroup(grIndex.toString(), model.editStatus.edit, false)">
                              </app-drop-down-item>
                              <app-drop-down-item class="width-100pcnt"
                                data-qa="fs-delete-gr"
                                [text]="'Delete'"
                                [menuItemClass]="'red'"
                                [iconNameAndStyling]="'delete.svg'"
                                (click)="deleteGroup(grIndex)">
                              </app-drop-down-item>
                            </ul>
                          </mat-menu>
                        </app-three-dots-menu>
                        <div class="font-4 bold600">{{ group.controls.name.value }}</div>
                      </div>
                      <app-button
                        [attr.data-qa]="'fs-add-sb' + grIndex"
                        [type]="'grey-accent'"
                        [size]="'xsmall'"
                        [iconName]="'plus.svg'"
                        [disabled]="isEditingProcess"
                        (click)="showNotificationForNewModel()"
                        (buttonClick)="addNewSubGroup(grIndex)">
                        Subgroup
                      </app-button>
                    </div>
                </td>
              </ng-template>
              <td class="blank-space"></td>
              <td colspan="3"></td>
              <td class="blank-space"></td>
              <td colspan="4"></td>
            </tr>
<!-- SUB GROUP -->
          <ng-container formArrayName="subGroups">
            <ng-container *ngFor="let subGroup of group.controls.subGroups.controls ; let sbIndex = index;" [formGroupName]="sbIndex" >
              <tr cdkDrag id="subGroup"  [cdkDragDisabled]="model.subGroup.editName.get(grIndex + '-' + sbIndex) || isEditingProcess">
<!-- EDIT SUB GROUP -->
                <ng-container *ngIf="model.subGroup.editName.get(grIndex + '-' + sbIndex); else subGroupViewState">
                  <td colspan="2">
                    <app-input
                      formControlName = "name"
                      [isShrinked]="true"
                      [attr.data-qa]="'fs-input-sub-gr-name-' + grIndex + '-' + sbIndex"
                      [suffixFirstIcon]="'close.svg; black-9'"
                      [suffixSecondIcon]="'check.svg; main-8'"
                      (suffixFirstIconEmitter)="editGroupOrSubGroup(grIndex + '-' + sbIndex, model.editStatus.decline, true)"
                      (suffixSecondIconEmitter)="editGroupOrSubGroup(grIndex + '-' + sbIndex, model.editStatus.confirm, true)">
                    </app-input>
                  </td>
                  <td class="blank-space"></td>
                  <td colspan="3"></td>
                  <td class="blank-space"></td>
                  <td colspan="4"></td>
                </ng-container>
<!-- VIEW SUB GROUP -->
                <ng-template #subGroupViewState >
                  <ng-container *ngIf="model.subGroup.visibility[grIndex]?.visible">
                    <td></td>
                    <td>
                      <div class="space-between-horizontal"  >
                        <div class="start-row-container row-gap-0p5" >
                            <app-all-icons
                              cdkDragHandle
                              [iconNameAndStyling]="'drop-icon.svg; icon-size-1p375; ' + (isEditingProcess ? 'opacity0p64 disabled cursor-not-allowed' : 'drag-icon cursor-grab')"
                              (click)="showNotificationForNewModel()">
                            </app-all-icons>
                          <app-three-dots-menu
                            [attr.data-qa]="'tree-dots-sub-gr' + grIndex + '-' + sbIndex"
                            [matMenuTriggerFor]="isEditingProcess ? '' : menu"
                            [disabled]="isEditingProcess"
                            [class.cursor-not-allowed]="isEditingProcess"
                            (click)="showNotificationForNewModel()">
                            <mat-menu #menu="matMenu">
                              <ul class="list">
                                <app-drop-down-item class="width-100pcnt"
                                  [attr.data-qa]="'fs-duplicate-sb' + grIndex + '-' + sbIndex"
                                  [text]="'Duplicate'"
                                  [iconNameAndStyling]="'copy.svg'"
                                  (click)="duplicateSubGroup(grIndex, sbIndex)">
                                </app-drop-down-item>
                                <app-drop-down-item class="width-100pcnt"
                                  [attr.data-qa]="'fs-edit-sb-name' + grIndex + '-' + sbIndex"
                                  [text]="'Edit'"
                                  [iconNameAndStyling]="'edit.svg'"
                                  (click)="editGroupOrSubGroup(grIndex + '-' + sbIndex, model.editStatus.edit, true)">
                                </app-drop-down-item>
                                <app-drop-down-item class="width-100pcnt"
                                  [attr.data-qa]="'fs-delete-sb' + grIndex + '-' + sbIndex"
                                  [text]="'Delete'"
                                  [menuItemClass]="'red'"
                                  [iconNameAndStyling]="'delete.svg'"
                                  (click)="deleteSubGroup(grIndex,sbIndex)">
                                </app-drop-down-item>
                              </ul>
                            </mat-menu>
                          </app-three-dots-menu>
                          <div>{{subGroup.controls.name.value}}</div>
                        </div>
                        <app-button
                          [attr.data-qa]="'fs-show-rounds' + grIndex + '-' + sbIndex"
                          [type]="'white-green'"
                          [size]="'xsmall'"
                          [showIcon]="'right'"
                          [iconName]="'right-arrow.svg'"
                          [disabled]="isEditingProcess"
                          (click)="showNotificationForNewModel()"
                          (buttonClick)="showRounds(subGroup, grIndex, sbIndex)">
                          {{subGroup.controls.roundsData.controls.length}} rounds
                        </app-button>
                      </div>
                    </td>
                    <ng-container *ngIf="subGroup.controls.roundsData.controls.length">
                      <ng-container formArrayName="roundsData">
                        <ng-container>
                          <td class="blank-space"></td>
                          <!-- start companies number -->
                          <td>{{subGroup.controls.roundsData.controls[0]?.controls.companiesNumber.value | switcherDashBraces: 1 : 0}}</td>
                          <td>{{calculateSubGroupTotalsWrapper(subGroup, model.totals.names.writeOff) | switcherDashBraces: 1 : 0 }}</td>
                          <td>{{calculateSubGroupTotalsWrapper(subGroup, model.totals.names.exitCompNumber) | switcherDashBraces: 1 : 0}}</td>
                          <td class="blank-space"></td>
                          <td>{{calculateSubGroupTotalsWrapper(subGroup, model.totals.names.investment) | switcherDashBraces: 1 : 0}}</td>
                          <td>{{calculateSubGroupTotalsWrapper(subGroup, model.totals.names.exitProceeds) | switcherDashBraces: 1 : 0 }}</td>
                          <td>{{calculateSubGroupTotalsWrapper(subGroup, model.totals.names.gain) | switcherDashBraces: 1 : 0}}</td>
                          <td>x{{calculateSubGroupTotalsWrapper(subGroup, model.totals.names.moic) | number : '1.2-2'}}</td>
                        </ng-container>
                      </ng-container>
                    </ng-container>

                  </ng-container>
                </ng-template>
              </tr>
            </ng-container>
          </ng-container>
<!-- SUBTOTALS -->
            <tr class="total" *ngIf="form.controls.fundStrategy.controls.length > 1">
              <td colspan="2">
                <div class="start-row-container pd-l-4">
                  Subtotal
                </div>
              </td>
              <td class="blank-space size-xxs"></td>
              <td>{{model.totals.subTotal[grIndex].companiesNumber | switcherDashBraces: 1 : 0 }}</td>
              <td>{{model.totals.subTotal[grIndex].writeOff | switcherDashBraces: 1 : 0 }}</td>
              <td>{{model.totals.subTotal[grIndex].exitCompNumber | switcherDashBraces: 1 : 0 }}</td>
              <td class="blank-space size-xxs"></td>
              <td>{{model.totals.subTotal[grIndex].investment | switcherDashBraces: 1 : 0}}</td>
              <td>{{model.totals.subTotal[grIndex].proceed | switcherDashBraces: 1 : 0}}</td>
              <td>{{model.totals.subTotal[grIndex].gain | switcherDashBraces: 1 : 0}}</td>
              <td>x{{model.totals.subTotal[grIndex].moic | number : '1.2-2'}}</td>
            </tr>
<!-- GRAND TOTAL -->
      </tbody>
      <tfoot>
        <tr class="grand-total">
          <td colspan="2">Total</td>
          <td class="blank-space size-xxs"></td>
          <td>{{model.totals.grand.companiesNumber | switcherDashBraces: 1 : 0 }}</td>
          <td>{{model.totals.grand.writeOff | switcherDashBraces: 1 : 0 }}</td>
          <td>{{model.totals.grand.exitCompNumber | switcherDashBraces: 1 : 0 }}</td>
          <td class="blank-space size-xxs"></td>
          <td>{{model.totals.grand.investment | switcherDashBraces: 1 : 0}}</td>
          <td>{{model.totals.grand.proceed | switcherDashBraces: 1 : 0}}</td>
          <td>{{model.totals.grand.gain | switcherDashBraces: 1 : 0}}</td>
          <td>x{{model.totals.grand.moic | number : '1.2-2'}}</td>
        </tr>
      </tfoot>
    </ng-container>
   </table>



<!-- ROUNDS -->
    <ng-container formArrayName="fundStrategy">
      <ng-container *ngFor="let group of form.controls.fundStrategy.controls; let grIndex = index;" [formGroupName]="grIndex">
        <ng-container formArrayName="subGroups">
          <ng-container *ngFor="let subGroup of group.controls.subGroups.controls ; let sbIndex = index;" [formGroupName]="sbIndex">
            <ng-container *ngIf="model.rounds.show.get(grIndex + '-' + sbIndex) && !model.showMainTable">
<!-- ROUNDS GREEN HEADER -->
              <div class="space-between-horizontal-centered green-manage-columns-header">
                <div class="centered-row-container row-gap-1" [ngClass]="model.rounds.areInEditMode ? 'opacity0p64 pointer' :''">
                  <app-button
                    [attr.data-qa]="'fs-go-to-groups-bttn-' + grIndex + '-' + sbIndex"
                    [type]="'accent-light'"
                    [size]="'xsmall'"
                    [iconName]="'arrow-left.svg'"
                    [disabled]="model.rounds.areInEditMode"
                    (buttonClick)="goToGroups(grIndex, sbIndex)">Back
                  </app-button>
                  <div  class="font-4 bold500 white-12"
                        [attr.data-qa]="'fs-go-to-groups-gr' + grIndex + '-' + sbIndex"
                        [class.clickable]="!model.rounds.areInEditMode"
                        (click)="goToGroups(grIndex, sbIndex)">{{group.controls.name.value}}</div>
                  <app-all-icons [iconNameAndStyling]="'right-arrow.svg; white-12'"></app-all-icons>
                  <div class="font-4 bold500 white-9">{{group.controls.subGroups.controls[sbIndex].controls.name.value}}</div>
                </div>
                <div class="centered-row-container row-gap-1">
                  <app-button *ngIf="!model.rounds.areInEditMode" [attr.data-qa]="'fs-edit-all-rounds' + grIndex + '-' + sbIndex" [type]="'white-green'" [size]="'xsmall'" [iconName]="'edit.svg'"  (buttonClick)="editAllRounds(grIndex + '-' + sbIndex, model.editStatus.edit); updateSubGroup(subGroup, grIndex, sbIndex)">Edit</app-button>
                  <app-button *ngIf="model.rounds.areInEditMode" [attr.data-qa]="'fs-cancel-edit-all-rounds' + grIndex + '-' + sbIndex" [type]="'accent'" [size]="'xsmall'" (buttonClick)="editAllRounds(grIndex + '-' + sbIndex, model.editStatus.decline)">Cancel</app-button>
                  <app-button *ngIf="model.rounds.areInEditMode" [attr.data-qa]="'fs-save-all-rounds' + grIndex + '-' + sbIndex" [type]="'white-green'" [size]="'xsmall'" [disabled]="!model.rounds.isAllCompaniesAllocated || model.rounds.input.error.get(grIndex + '-' + sbIndex + '-' + 0)" (buttonClick)="editAllRounds(grIndex + '-' + sbIndex, model.editStatus.confirm)">Save</app-button>
                </div>
              </div>
<!-- ROUNDS TABLE -->
              <div cdkDropList class="table-fms drop-list" (cdkDropListDropped)="cdkDropRound($event, subGroup, grIndex, sbIndex)">
                <table >
                  <thead>
                    <tr>
                        <th *ngIf="model.rounds.editMode.get(grIndex +'-'+ sbIndex)"></th>
                        <th class="size-s">
                          <div class="start-row-container row-gap-0p5">
                            <app-three-dots-menu data-qa="three-dots-header"
                                                 [disabled]="isEditingProcess" [matMenuTriggerFor]="isEditingProcess ? '' : menu"/>
                            <mat-menu #menu="matMenu">
                              <ul class="list">
                                <app-drop-down-item class="width-100pcnt"
                                                    data-qa="fs-export-excel"
                                                    [text]="'Export'"
                                                    [iconNameAndStyling]="'excel.svg'"
                                                    (click)="exportRoundsTable(grIndex, sbIndex)">
                                </app-drop-down-item>
                              </ul>
                            </mat-menu>
                            <span>Round name</span>
                          </div>
                        </th>
                        <th class="size-xs">ESOP, %</th>
                        <th class="size-xs">Pre-money</th>
                        <th class="size-xs">Round</th>
                        <th class="size-xs">Post-money</th>
                        <th class="size-xs blank-space"></th>
                        <th class="size-xs">
                          <div class="start-column-container">
                            <span>Investment</span>
                            <span class="caption-2 bold400 black-10">Companies</span>
                          </div>
                        </th>
                        <th class="size-xs">
                          <div class="start-column-container">
                            <span>Investment</span>
                            <span class="caption-2 bold400 black-10">Amount</span>
                          </div>
                        </th>
                        <th class="size-xs">
                          <div class="start-column-container">
                            <span>Holding</span>
                            <span class="caption-2 bold400 black-10">%</span>
                          </div>
                        </th>
                        <th class="size-xs blank-space"></th>

                        <th class="size-xs">Exit. comp</th>
                        <th class="size-xs">Comp. value</th>
                        <th class="size-xs">Proceeds</th>
                        <th class="size-xs blank-space"></th>
                        <th class="size-xs">
                          <div class="start-column-container">
                            <span>Write-off</span>
                            <span class="caption-2 bold400 black-10">Companies</span>
                          </div>
                        </th>
                        <th class="size-xs blank-space"></th>

                        <th class="size-xs">
                          <div class="start-column-container">
                            <span>Investment</span>
                            <span class="caption-2 bold400 black-10">Total</span>
                          </div>
                        </th>
                        <th class="size-xs">
                          <div class="start-column-container">
                            <span>Proceed</span>
                            <span class="caption-2 bold400 black-10">Total</span>
                          </div>
                        </th>
                        <th class="size-xs">
                          <div class="start-column-container">
                            <span>MOIC</span>
                            <span class="caption-2 bold400 black-10">Total</span>
                          </div>
                        </th>
                    </tr>
                  </thead>
                  <tbody>
  <!-- ROUNDS LIST -->
                    <ng-container formArrayName="roundsData" *ngVar="model.rounds.input.error.get(grIndex + '-' + sbIndex + '-' + 0) as inputsErrorState">
                      <ng-container  *ngFor="let roundsData of subGroup.controls.roundsData.controls; let rIndex = index;"
                                      [formGroupName]="rIndex"
                                     >
  <!-- EDIT ROUND -->  <tr></tr>
                        <tr  *ngIf="model.rounds.editMode.get(grIndex +'-'+ sbIndex); else viewRoundMode"
                                    cdkDrag id="round"
                                    [cdkDragDisabled]="inputsErrorState">
                          <td id="twoLinesIcon"  data-qa="two-lines-drag-and-drop">
                                <app-all-icons class="drag-svg clickable" cdkDragHandle
                                  [class.disabled-icon]="inputsErrorState"
                                  [iconNameAndStyling]="'drop-icon.svg;drag-icon icon-size-1p375 cursor-grab'">
                                </app-all-icons>
                          </td>
                          <td>
                            <div class="start-row-container row-gap-0p5">
                              <app-three-dots-menu [attr.data-qa]="'tree-dots-round' + grIndex + '-' + sbIndex + '-' + rIndex" [matMenuTriggerFor]="menu" class="clickable">
                                <mat-menu #menu="matMenu">
                                  <ul class="list">
                                    <app-drop-down-item class="width-100pcnt"
                                      [attr.data-qa]="'fs-duplicate-round' + grIndex + '-' + sbIndex + '-' + rIndex"
                                      [text]="'Duplicate'"
                                      [iconNameAndStyling]="'copy.svg'"
                                      (click)="duplicateRound(grIndex, sbIndex, rIndex)">
                                    </app-drop-down-item>
                                    <app-drop-down-item class="width-100pcnt"
                                      [attr.data-qa]="'fs-delete-round' + grIndex + '-' + sbIndex + '-' + rIndex"
                                      [text]="'Delete'"
                                      [menuItemClass]="'red'"
                                      [iconNameAndStyling]="'delete.svg'"
                                      (click)="deleteRound(grIndex, sbIndex, rIndex)">
                                    </app-drop-down-item>
                                  </ul>
                                </mat-menu>
                              </app-three-dots-menu>
                              <app-input-autocomplete class="fs-input-autocomplete width-100pcnt"
                                formControlName = "name"
                                [additionalContainerClass]="'control-shrinked-container'"
                                [attr.data-qa]="'fs-input-round-name-' + rIndex"
                                [data]="model.rounds.suggestedNames"
                                [selectedObject]="roundsData.controls.name.value" ></app-input-autocomplete>
                            </div>
                          </td>
                          <td class="width-2">
                            <app-input  formControlName = "esop"
                                        [attr.data-qa]="'fs-input-esop' + grIndex + '-' + sbIndex + '-' + rIndex"
                                        [thousandSeparator]="','"
                                        [isShrinked]="true"
                                        [separator]="'separator.2'"
                                        [suffix]="'%'"
                                        (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                            </app-input>
                          </td>
                          <td class="width-6">
                            <app-input  formControlName = "preMoney"
                                        [attr.data-qa]="'fs-input-preMoney' + grIndex + '-' + sbIndex + '-' + rIndex"
                                        [thousandSeparator]="','"
                                        [isShrinked]="true"
                                        [separator]="'separator.0'"
                                        (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                            </app-input>
                          </td>
                          <td class="width-6">
                            <app-input  formControlName = "round"
                                        [attr.data-qa]="'fs-input-round' + grIndex + '-' + sbIndex + '-' + rIndex"
                                        [thousandSeparator]="','"
                                        [isShrinked]="true"
                                        [separator]="'separator.0'"
                                        (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                            </app-input>
                          </td>
                          <!-- post-money -->
                          <td class="width-6">{{(+roundsData.controls.preMoney.value + +roundsData.controls.round.value) | switcherDashBraces: 1 : 0}}</td>
                          <td class="blank-space"></td>
                          <td  class="width-2">
                            <app-input  *ngIf="rIndex === 0"
                                        formControlName = "companiesNumber"
                                        [attr.data-qa]="'fs-input-companiesNumber' + grIndex + '-' + sbIndex + '-' + rIndex"
                                        [separator]="'separator.0'"
                                        [isShrinked]="true"
                                        [additionalClass]="model.rounds.input.error.get(grIndex + '-' + sbIndex + '-' + rIndex) ? 'error' : ''"
                                        (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                            </app-input>
                            <div *ngIf="rIndex > 0"
                                 class="padding-borders-0p5 width-fit-content"
                                 [id]="'unallocatedCompanies_'+rIndex"
                                 [ngClass]="{'orange-10 clickable': model.rounds.unallocatedCompanies.get(grIndex + '-' + sbIndex + '-' + rIndex)}"
                                 (mouseenter)="activateTooltip(grIndex, sbIndex, rIndex, 'unallocatedCompanies_')"
                                 (mouseleave)="closeTooltip()">
                                 {{roundsData.controls.companiesNumber.value | switcherDashBraces: 1 : 0}}
                            </div>
                          </td>

                          <td class="width-6">
                            <app-input  formControlName = "investment"
                                        [attr.data-qa]="'fs-input-investment' + grIndex + '-' + sbIndex + '-' + rIndex"
                                        [thousandSeparator]="','"
                                        [isShrinked]="true"
                                        [separator]="'separator.0'"
                                        (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                            </app-input>
                          </td>
                          <td class="width-2">{{roundsData.controls.holding.value | percent:'1.2-2'}}</td>
                          <td class="blank-space"></td>
                          <td class="width-2">
                            <app-input  formControlName = "exitCompNumber"
                                        [attr.data-qa]="'fs-input-exitCompNumber' + grIndex + '-' + sbIndex + '-' + rIndex"
                                        [separator]="'separator.0'"
                                        [isShrinked]="true"
                                        [additionalClass]="model.rounds.input.error.get(grIndex + '-' + sbIndex + '-' + rIndex) ? 'error' : ''"
                                        (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                            </app-input>
                          </td>
                          <td class="width-6">
                            <app-input  formControlName = "exitCompPrice"
                                        [attr.data-qa]="'fs-input-exitCompPrice' + grIndex + '-' + sbIndex + '-' + rIndex"
                                        [thousandSeparator]="','"
                                        [isShrinked]="true"
                                        [separator]="'separator.0'"
                                        (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                            </app-input>
                          </td>
                          <!-- Proceeds -->
                          <td class="width-6">{{roundsData.controls.holding.value * roundsData.controls.exitCompPrice.value | switcherDashBraces: 1 : 0}}</td>
                          <td class="blank-space"></td>
                          <td  class="width-2">
                            <app-input  formControlName = "writeOff"
                                        [attr.data-qa]="'fs-input-writeOff' + grIndex + '-' + sbIndex + '-' + rIndex"
                                        [separator]="'separator.0'"
                                        [isShrinked]="true"
                                        [additionalClass]="model.rounds.input.error.get(grIndex + '-' + sbIndex + '-' + rIndex) ? 'error' : ''"
                                        (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                            </app-input>
                          </td>
                          <td class="blank-space"></td>
                          <!-- total investment -->
                          <td class="width-6">{{roundsData.controls.companiesNumber.value * roundsData.controls.investment.value | switcherDashBraces: 1 : 0}}</td>
                          <!-- exitProceeds -->
                          <td class="width-6">{{roundsData.controls.holding.value * roundsData.controls.exitCompNumber.value * roundsData.controls.exitCompPrice.value | switcherDashBraces: 1 : 0}}</td>
                          <td></td>
                        </tr>
  <!-- VIEW ROUND -->
                        <ng-template #viewRoundMode>
                            <tr>
                              <td>{{roundsData.controls.name.value}} </td>
                              <td>{{roundsData.controls.esop.value | switcherDashBraces: 1 : 2}}</td>
                              <td>{{roundsData.controls.preMoney.value | switcherDashBraces: 1 : 0}}</td>
                              <td>{{roundsData.controls.round.value | switcherDashBraces: 1 : 0}}</td>
                               <!-- post-money -->
                              <td>{{roundsData.controls.postMoney.value | switcherDashBraces: 1 : 0}}</td>
                              <td class="blank-space"></td>
                              <td>
                                  <div
                                    [id]="'unallocatedCompanies_'+rIndex"
                                    [ngClass]="{'orange-10 clickable width-fit-content': model.rounds.unallocatedCompanies.get(grIndex + '-' + sbIndex + '-' + rIndex)}"
                                    (mouseenter)="activateTooltip(grIndex, sbIndex, rIndex, 'unallocatedCompanies_')"
                                    (mouseleave)="closeTooltip()">
                                    {{roundsData.controls.companiesNumber.value | switcherDashBraces: 1 : 0}}
                                  </div>
                              </td>
                              <td>{{roundsData.controls.investment.value | switcherDashBraces: 1 : 0}}</td>
                              <td>{{roundsData.controls.holding.value | percent:'1.2-2'}}</td>
                              <td class="blank-space"></td>
                              <td>{{roundsData.controls.exitCompNumber.value | switcherDashBraces: 1 : 0}}</td>
                              <td>{{roundsData.controls.exitCompPrice.value | switcherDashBraces: 1 : 0}}</td>
                              <td>{{roundsData.controls.proceeds.value | switcherDashBraces: 1 : 0 }}</td>
                              <td class="blank-space"></td>
                              <td>{{roundsData.controls.writeOff.value | switcherDashBraces: 1 : 0}}</td>
                              <td class="blank-space"></td>
                              <td>{{roundsData.controls.totalInvestment.value | switcherDashBraces: 1 : 0}}</td>
                              <td>{{roundsData.controls.exitProceeds.value | switcherDashBraces: 1 : 0}}</td>
                              <td></td>
                            </tr>
                        </ng-template>
                      </ng-container>
  <!-- ADD NEW ROUND -->
                        <tr *ngIf="model.rounds.areInEditMode">
                          <td colspan="6">
                            <div class="start-row-container row-gap-1 pd-l-0p5 clickable" [attr.data-qa]="'fs-add-new-round' + grIndex + '-' + sbIndex" (click)="addNewRound(grIndex, sbIndex)" >
                              <app-all-icons [iconNameAndStyling]="'plus.svg; main-8'"></app-all-icons>
                              <span class="main-8 bold500">Round</span>
                            </div>
                          </td>
                          <td class="blank-space"></td>
                          <td colspan="3"></td>
                          <td class="blank-space"></td>
                          <td colspan="3"></td>
                          <td class="blank-space"></td>
                          <td></td>
                          <td class="blank-space"></td>
                          <td colspan="2"></td>
                        </tr>
                        <tr class="grand-total">
                          <td *ngIf="model.rounds.editMode.get(grIndex +'-'+ sbIndex)"></td>
                          <td colspan="3">Total {{group.controls.subGroups.controls[sbIndex].controls.name.value}}</td>
                          <td>{{calculateSubGroupTotalsWrapper(subGroup, model.totals.names.round) | switcherDashBraces: 1 : 0 }}</td>
                          <td></td>
                          <td class="blank-space"></td>
                          <td colspan="3">{{subGroup.controls.roundsData.controls[0]?.controls.companiesNumber.value | switcherDashBraces: 1 : 0}}</td>
                          <td class="blank-space"></td>
                          <td colspan="3">{{calculateSubGroupTotalsWrapper(subGroup, model.totals.names.exitCompNumber) | switcherDashBraces: 1 : 0}}</td>
                          <td class="blank-space"></td>
                          <td>{{calculateSubGroupTotalsWrapper(subGroup, model.totals.names.writeOff) | switcherDashBraces: 1 : 0 }}</td>
                          <td class="blank-space"></td>
                          <td>{{calculateSubGroupTotalsWrapper(subGroup, model.totals.names.investment) | switcherDashBraces: 1 : 0}}</td>
                          <td>{{calculateSubGroupTotalsWrapper(subGroup, model.totals.names.exitProceeds) | switcherDashBraces: 1 : 0 }}</td>
                          <td>{{calculateSubGroupTotalsWrapper(subGroup, model.totals.names.moic) | switcherDashBraces: 1 : 2: false : 'x'}}</td>
                        </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
  </div>
</form>

<app-tooltip
  *ngIf="toolTipSettings.show"
  [coordinates]="toolTipSettings.coordinates"
  [title]="toolTipSettings.title"
/>
